const DevicesList = {
  DEFAULT: 'default',
  ANDROID: 'android',
  LG: 'lg',
  SAMSUNG: 'samsung',
  TIZEN: 'tizen',
  TIZEN_TEP: 'tizenTEP',
  PHILIPS: 'philips',
  DUNEHD: 'dunehd',
  VIERA: 'viera',
  Alliance: 'alliance',
  Playstation: 'playstation',
  WEBOS: 'webos',
  ARRIS: 'arris',
  HISENSE: 'hisense',
};

const obj = { DevicesList };

export default obj;
